/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbTabsetModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { AppConfigService } from './@core/mock/AppConfigService';
import { APP_BASE_HREF, registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { NgxLoginComponent } from './pages/forms/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NbRoleProvider } from '@nebular/security';
import { RoleProvider } from './@core/mock/role.provider';
import { AuthGuard } from './@core/mock/auth-guard.service';
import { bitLogoutComponent } from './pages/forms/logout/logout.component';
registerLocaleData(localeEs, 'es-AR');

const appInitializerFn = (appConfig: AppConfigService) => {
  return () => appConfig.loadAppConfig();
};
@NgModule({
  declarations: [AppComponent, NgxLoginComponent,bitLogoutComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    ThemeModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    
  ],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AppConfigService]
    },
    {
      provide: APP_BASE_HREF, useValue: ' /',
    }, AuthGuard,
    //PermissionGuard,
    { provide: LOCALE_ID, useValue: 'es-AR' },
    { provide: NbRoleProvider, useClass: RoleProvider },
  ]
})
export class AppModule {
}
